
class mapViewHelper {

    constructor() {
        if (typeof mapboxgl === "object") {
            mapboxgl.accessToken = 'pk.eyJ1Ijoiam1vbGxtYW4iLCJhIjoiY2syNHUyZndyMGNoZjNobW5hZXU1djM4eiJ9.O-dQZijwjI3Q3oyBCC0h6g';

            // This adds the map to your page
            var map = new mapboxgl.Map({
                // container id specified in the HTML
                container: 'map',
                // style URL
                style: 'mapbox://styles/mapbox/light-v10',
                // initial position in [lon, lat] format
                center: [-98.556061, 39.810492],
                // initial zoom
                zoom: 3
            });

            // This will let you use the .remove() function later on
            if (!('remove' in Element.prototype)) {
                Element.prototype.remove = function () {
                    if (this.parentNode) {
                        this.parentNode.removeChild(this);
                    }
                };
            }


            // Add an event listener for when a user clicks on the map
            map.on('click', function (e) {
                // Query all the rendered points in the view
                var features = map.queryRenderedFeatures(e.point, { layers: ['locations'] });
                if (features.length) {
                    var clickedPoint = features[0];
                    // 1. Fly to the point
                    app.mapView.flyToStore(map, clickedPoint);
                    // 2. Close all other popups and display popup for clicked store
                    app.mapView.createPopUp(map, clickedPoint);
                    // 3. Highlight listing in sidebar (and remove highlight for all other listings)
                    var activeItem = document.getElementsByClassName('active');
                    if (activeItem[0]) {
                        activeItem[0].classList.remove('active');
                    }
                    // Find the index of the store.features that corresponds to the clickedPoint that fired the event listener
                    var selectedFeature = clickedPoint.properties.address;

                    for (var i = 0; i < stores.features.length; i++) {
                        if (stores.features[i].properties.address === selectedFeature) {
                            selectedFeatureIndex = i;
                        }
                    }
                    // Select the correct list item using the found index and add the active class
                    var listing = document.getElementById('listing-' + selectedFeatureIndex);
                    listing.classList.add('active');
                }
            });

            map.on('load', function (e) {
                app.mapView.getUserLocation(map)
                .then((returnVal) => {
                    locations = app.mapView.getData(map);
                    map.loadImage('/assets/images/map_marker.png', function (error, image) {
                        if (error) throw error;
                        map.addImage('map-marker', image);
                    });
                    map.loadImage('/assets/images/map_marker_orange.png', function (error, image_orange) {
                        if (error) throw error;
                        map.addImage('map-marker-orange', image_orange);
                    });
                })
                .catch(err => console.log("Axios err: ", err))
            });
        }

    }

    init() {
    }

    create() {
        // console.log('Creating the map');
    }

    buildLocationList(map, data) {
        // Iterate through the list of stores
        for (i = 0; i < data.features.length; i++) {
            var currentFeature = data.features[i];
            // Shorten data.feature.properties to `prop` so we're not
            // writing this long form over and over again.
            var prop = currentFeature.properties;
            // Select the listing container in the HTML and append a div
            // with the class 'item' for each store
            var listings = document.getElementById('listings');
            var listing = listings.appendChild(document.createElement('div'));
            listing.className = 'item';
            listing.id = 'listing-' + i;

            // Create a new link with the class 'title' for each store
            // and fill it with the store address
            var link = listing.appendChild(document.createElement('a'));
            link.href = '#';
            // link.className = 'title';
            link.dataPosition = i;
            // link.innerHTML = prop.title;
            var main_div = link.appendChild(document.createElement('div'));
            main_div.className = 'row';
            var left_div = main_div.appendChild(document.createElement('div'));
            left_div.className = 'col-xl-4 bg-image';
            left_div.style.backgroundImage = "url('"+prop.image_url+"')";
            var right_div = main_div.appendChild(document.createElement('div'));
            right_div.className = 'col-xl-8 d-flex justify-content-between py-15';
            // Create a new div with the class 'details' for each store
            // and fill it with the city and phone number
            var div_left = right_div.appendChild(document.createElement('div'));
            var h5 = div_left.appendChild(document.createElement('h5'));
            h5.innerHTML = prop.title;
            h5.className = "fz-16";
            var p = div_left.appendChild(document.createElement('p'));
            p.innerHTML = prop.address;
            p.innerHTML += "<br>" + prop.city + ", " + prop.state + " " + prop.postalCode;
            p.innerHTML += "<br>" + prop.phone;
            var div_right = right_div.appendChild(document.createElement('div'));
            var p = div_right.appendChild(document.createElement('p'));

            p.innerHTML = prop.distance + " mi";
            p.className = "distance";

            // p.innerHTML += '<br><a href="' + prop.link +'" class="color-nelson-blue">View location details <i class="fal fa-chevron-right ml-1 fz-15" /></a>';

            // Add an event listener for the links in the sidebar listing
            link.addEventListener('click', function (e) {
                // Update the currentFeature to the store associated with the clicked link
                var clickedListing = data.features[this.dataPosition];
                // 1. Fly to the point associated with the clicked link
                app.mapView.flyToStore(map, clickedListing);
                // 2. Close all other popups and display popup for clicked store
                app.mapView.createPopUp(map, clickedListing);
                // 3. Highlight listing in sidebar (and remove highlight for all other listings)
                var activeItem = document.getElementsByClassName('active');
                if (activeItem[0]) {
                    activeItem[0].classList.remove('active');
                }
                this.parentNode.classList.add('active');
            });

        }
    }

    flyToStore(map, currentFeature) {
        map.flyTo({
            center: currentFeature.geometry.coordinates,
            zoom: 5
        });
    }

    createPopUp(map, currentFeature) {
        var popUps = document.getElementsByClassName('mapboxgl-popup');
        // Check if there is already a popup on the map and if so, remove it
        if (popUps[0]) popUps[0].remove();

        var popup = new mapboxgl.Popup({ closeOnClick: false })
            .setLngLat(currentFeature.geometry.coordinates)
            .setHTML('<h3>' + currentFeature.properties.title + '</h3>' +
                '<p>' + currentFeature.properties.address + '<br><a href="' + currentFeature.properties.link + '" class="color-nelson-blue">View location details <i class="fal fa-chevron-right ml-1 fz-15" /></a></p>')
            .addTo(map);
    }

    getUserLocation(map) {
        const axios = require('axios');
         return axios.get('https://geolocation-db.com/json/').then(response => {
             window.app.lat = response.data.latitude;
             window.app.lng = response.data.longitude;
            map.easeTo({ center: [response.data.longitude, response.data.latitude] });

            features = [];
            features.push({
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        response.data.longitude,
                        response.data.latitude
                    ]
                },
                "properties": {
                    "title": "Current location",
                }
            });
            data = {
                "type": "FeatureCollection",
                "features": features
            }
            map.addLayer({
                id: 'points',
                type: 'symbol',
                // Add a GeoJSON source containing place coordinates and information.
                source: {
                    type: 'geojson',
                    data: data
                },
                layout: {
                    'icon-image': 'map-marker-orange',
                    'icon-allow-overlap': true,
                }
            });
        });
    }

    getData(map) {
        const axios = require('axios');
        axios.get('/wp-json/usdp/v1/locations', {
            params: {
              lng: window.app.lng,
              lat: window.app.lat
            }
          }).then(response => {
            features = [];
            response.data.forEach(function (location) {
                features.push({
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [
                            location.longitude,
                            location.latitude
                        ]
                    },
                    "properties": {
                        "title": location.post_title,
                        "phone": location.office_phone_number,
                        "address": location.street_address,
                        "city": location.city,
                        "country": "United States",
                        "postalCode": location.zip,
                        "state": location.state,
                        "link": location.link,
                        "distance": location.distance,
                        "image_url": location.image_url
                    }
                })
            });
            data = {
                "type": "FeatureCollection",
                "features": features
            }

            map.addLayer({
                id: 'locations',
                type: 'symbol',
                // Add a GeoJSON source containing place coordinates and information.
                source: {
                    type: 'geojson',
                    data: data
                },
                layout: {
                    'icon-image': 'map-marker',
                    'icon-allow-overlap': true,
                }
            });

            app.mapView.buildLocationList(map, data)
        });

    }

}

window.app.add('mapView', new mapViewHelper());